import React from "react";

// Lotus flower divider (gold) to match original design
export default function FlowerDivider({ size = 44 }) {
  return (
    <div className="flex items-center justify-center gap-5 my-8 text-[var(--gold)]">
      <span className="h-px w-20 bg-[var(--gold)]/50" />
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <g stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="32" cy="18" r="8" />
          <circle cx="18" cy="32" r="8" />
          <circle cx="46" cy="32" r="8" />
          <circle cx="32" cy="46" r="8" />
        </g>
      </svg>
      <span className="h-px w-20 bg-[var(--gold)]/50" />
    </div>
  );
}
